import React from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import { Dialog } from '@mui/material';
import Text from 'components/Text';
import { IconButton } from 'components/Button';
import Model from '../../../../../model';

import './index.sass';
import Icon from 'components/Icon';

const { block, el } = bem('checkout-form-success-modal');

const CheckoutFormSuccessModal = () => {

    const { modal } = Model;
    const { isMobile } = useMobile();

    const handleClose = () => {
        modal.closeCheckoutFormSuccess();
    }

    return (
        <Dialog
            className={block()}
            open={ modal.isCheckoutFormSuccessOpen }
            onClose={ handleClose }
            fullWidth={ true }
            fullScreen={ isMobile }
            maxWidth={ 'md' }
            scroll={'body'}
            PaperProps={ {
                sx: {
                    maxWidth: 1024,
                    margin: '0 auto',
                    width: 1024,
                    borderRadius: isMobile ? 0 : '20px'
                }
            } }
        >
            <div className={el('content')}>
                <div className={el('header')}>
                    <div className={el('close')} onClick={handleClose}><Icon name={'x'}/></div>
                </div>
                <div className={el('top-block')}>
                    <div className={el('stars')} />
                    <div className={el('message')}>
                        <div className={el('title')}>
                            <Text tag={'div'} serif>{`Ваш заказ успешно оплачен `}
                            </Text>
                        </div>
                        <div className={el('description')}>
                            Мы уже начали собирать заказ
                        </div>
                    </div>
                </div>
                <div className={el('buttons')}>
                    <IconButton name={'arrow-counter-clockwise'} to={'/goods'} mod={'transparent-gold'}><Text>Продолжить покупки</Text></IconButton>
                    <IconButton name={'user-circle'} to={'/items'} mod={'gold'}><Text>В личный кабинет</Text></IconButton>
                </div>
            </div>
        </Dialog>
    )
}

export default observer(CheckoutFormSuccessModal);
